var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComingsoonActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32006_5379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0976563 23.8672C0.0976563 24.4385 0.561523 24.9023 1.13281 24.9023H23.8721C24.4434 24.9023 24.9072 24.4385 24.9072 23.8672V18.6816H0.0976563L0.0976563 23.8672ZM0.0976563 1.13281L0.0976563 6.31836H24.9023V1.13281C24.9023 0.561523 24.4385 0.0976562 23.8672 0.0976562H1.13281C0.561523 0.0976562 0.0976563 0.561523 0.0976563 1.13281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0976563 6.31836L0.0976562 18.6816H24.9023V6.31836L0.0976563 6.31836Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84766 12.5C7.84766 15.2686 10.0889 17.5098 12.8574 17.5098C13.1113 17.5098 13.3652 17.4902 13.6094 17.4512C15.5381 17.1631 17.1055 15.7764 17.6523 13.9502C17.7939 13.4912 17.8672 13.0029 17.8672 12.5C17.8672 12.2412 17.8477 11.9824 17.8086 11.7383C17.5156 9.81934 16.1289 8.25195 14.3027 7.70508C13.8438 7.56348 13.3604 7.49023 12.8574 7.49023C10.0889 7.49023 7.84766 9.73633 7.84766 12.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19336 20.0742V23.5117H6.63086V20.0742H3.19336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3633 20.0742V23.5117H21.8008V20.0742H18.3633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 20.0742V23.5117H14.2188V20.0742H10.7812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19336 1.48828V4.92578H6.63086V1.48828H3.19336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3633 1.48828V4.92578H21.8008V1.48828H18.3633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 1.48828V4.92578H14.2188V1.48828H10.7812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.165 11.2182L11.2246 8.64492C10.8145 8.37636 10.2676 8.66933 10.2676 9.1625V14.309C10.2676 14.8021 10.8145 15.0951 11.2246 14.8266L15.165 12.2533C15.541 12.0092 15.541 11.4623 15.165 11.2182Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 24.75,
    width: 24.5,
    height: 24.5,
    rx: 0.75,
    transform: "rotate(-90 0.25 24.75)",
    stroke: "black",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32006_5379"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 25,
    width: 25,
    height: 25,
    rx: 1,
    transform: "rotate(-90 0 25)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingsoonActive);
export default __webpack_public_path__ + "static/media/comingsoon-active.76014c2af6eb27c97d85312b04e61b4a.svg";
export { ForwardRef as ReactComponent };